var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"automation-integration-attributes-menu"},[_c('menu-collapse',{attrs:{"title":_vm.title}},_vm._l((_vm.attributes),function(attr){return _c('div',{key:attr.id},[_c('small',[_vm._v(_vm._s(attr.label))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }